<template>
  <div class="auth-page min-vh-100 d-flex align-items-center">
    <div class="container">
      <div class="row align-items-center g-4">
        <div class="col-lg-6 d-none d-lg-block">
          <div class="text-white pe-4">
            <div class="mb-4">
              <span
                class="badge bg-light text-primary rounded-pill px-3 py-2 fw-semibold"
              >
                ระบบการจัดดูแลค่าส่วนกลาง
              </span>
            </div>
            <h1 class="display-5 fw-bold mb-3">
              บริหารค่าส่วนกลาง
            </h1>
            <p class="lead text-white-50 mb-4">
              จัดการยูนิต ลูกบ้าน ใบแจ้งหนี้ การชำระเงิน และรายงานต่าง ๆ
            </p>

            <div class="row g-3">
              <div class="col-md-6">
                <div class="feature-box">
                  <i class="bi bi-receipt-cutoff fs-3"></i>
                  <div class="mt-2 fw-semibold">จัดการใบแจ้งหนี้</div>
                  <div class="small text-white-50">
                    สร้างและติดตามบิลได้ง่าย
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="feature-box">
                  <i class="bi bi-cash-coin fs-3"></i>
                  <div class="mt-2 fw-semibold">รับชำระเงิน</div>
                  <div class="small text-white-50">
                    ดูประวัติการชำระได้ชัดเจน
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.auth-page {
  background: radial-gradient(
      circle at top left,
      rgba(255, 255, 255, 0.12),
      transparent 30%
    ),
    linear-gradient(135deg, #0d6efd 0%, #084298 100%);
}

.feature-box {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 1rem;
  padding: 1rem;
  backdrop-filter: blur(8px);
}
</style>
